module.exports = __webpack_public_path__ + "img/green_024.2fec8708.png";